module.exports = __webpack_public_path__ + "img/warning-7.51ae6b8b.png";